import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import { arrayMax } from "highcharts";

const ProductHighlight = ({
  filesNew,
  deletedHighlight,
  filesDescsNew,
  productDetail,
  productHighlights,
  productHighlight,
  deletedFileNew,
  selectedLang,
  setState,
  wrapStyle2,
  onAddFileDescImage,
  onDetailChangeTextHighlight,
  onFileChangeImage,
  onRemoveFileImage,
  removeRow,
  resetRow,
  addRow,
  onHighlightSave,
  approval_status,
  next_step_nik_detail,
}) => {
  if (!filesNew) filesNew = [];
  if (filesDescsNew) {
    if (Array.isArray(filesDescsNew)) {
      const result = {};
      for (let key in filesDescsNew) {
        result[filesDescsNew[key].file_name] = filesDescsNew[key];
      }
      filesDescsNew = result;
    } else {
      let newObj = {};
      for (let key of Object.keys(filesDescsNew)) {
        newObj[key] = filesDescsNew[key];
      }
      filesDescsNew = newObj;
    }
  }

  let { userInfo } = useSelector((state) => state.auth);
  const genFileIndex = (file) => {
    return file.file_name || file.fileName;
  };
  return (
    <div>
      <div className="card mt-3">
        <div className="card-header">
          <div className="card-title" style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div>
                <i className="fa fa-camera" /> Product Banner Highlight
              </div>
              {
                filesNew.length == 0 ? (
                  <div>
                    <input
                      disabled={
                        productDetail.language_code &&
                        (approval_status == "ONPROGRESS" ||
                          (approval_status == "ONREVISED" &&
                            next_step_nik_detail != userInfo.nik))
                      }
                      id="file-image-highlight"
                      className="d-none"
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      onChange={onFileChangeImage}
                      multiple={false}
                    />
                    {(!approval_status ||
                      approval_status == "NOT SUBMITTED" ||
                      approval_status == "COMPLETED" ||
                      approval_status == "REJECTED" ||
                      (approval_status == "ONREVISED" &&
                        next_step_nik_detail == userInfo.nik)) && (
                        <a
                          type="button"
                          className={
                            productDetail.language_code
                              ? "btn btn-outline-warning"
                              : "mati btn btn-outline-warning"
                          }
                          style={{ width: 120 }}
                          onClick={() => {
                            window.$("#file-image-highlight").click();
                          }}
                        >
                          <i className="fa fa-image" /> Choose{" "}
                        </a>
                      )}
                  </div>
                ) : (
                  ""
                )
                // <div>
                //     <input id="file-image-highlight" className='d-none' type="file" accept="image/png, image/jpg, image/jpeg" onChange={onFileChangeImage} multiple={true} />
                //     <a type='button' className="disabled btn btn-outline-warning" style={{ width: 120 }} onClick={() => { window.$("#file-image-highlight").click() }}><i className='fa fa-image' /> Choose </a>
                // </div>
              }
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="form-group">
            <div
              className="d-flex"
              style={{ margin: "16px 0", flexFlow: "wrap", padding: 10 }}
            >
              {filesNew &&
                filesNew.length > 0 &&
                filesNew.map((file, i) => {
                  let fileIndex = genFileIndex(file);
                  /*if (!filesDescsNew[fileIndex] && file.fileIndex)
                    fileIndex = file.fileIndex;*/
                  return (
                    <div key={"key_file_" + i} style={{ display: "flex" }}>
                      <div style={wrapStyle2}>
                        <div
                          style={{ position: "absolute", right: -10, top: -10 }}
                        >
                          <Button
                            disabled={
                              approval_status != "" &&
                              approval_status != "NOT SUBMITTED" &&
                              approval_status != "COMPLETED" &&
                              approval_status != "REJECTED" &&
                              (approval_status != "ONREVISED" ||
                                next_step_nik_detail != userInfo.nik)
                            }
                            type="button"
                            className="p-button-rounded p-button-danger"
                            icon="pi pi-times"
                            style={{ width: 30, height: 30 }}
                            onClick={onRemoveFileImage(file, i)}
                          />
                        </div>
                        {file.url ? (
                          <img
                            src={file.url}
                            style={{
                              objectFit: "cover",
                              width: "358.67px",
                              height: "133.33px",
                              borderRadius: 4,
                              marginBottom: 20,
                              cursor: "pointer",
                            }}
                            onClick={() => onAddFileDescImage(file)}
                          />
                        ) : (
                          <img
                            src={URL.createObjectURL(file)}
                            style={{
                              objectFit: "cover",
                              width: "358.67px",
                              height: "133.33px",
                              borderRadius: 4,
                              marginBottom: 20,
                              cursor: "pointer",
                            }}
                            onClick={() => onAddFileDescImage(file)}
                          />
                        )}
                      </div>
                      {filesDescsNew[fileIndex] &&
                        filesDescsNew[fileIndex].media_types &&
                        filesDescsNew[fileIndex].content_types &&
                        (filesDescsNew[fileIndex].media_types?.length > 0 ||
                          filesDescsNew[fileIndex].content_types?.length >
                          0) && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              marginRight: 10,
                            }}
                          >
                            <div style={{ width: 85, marginTop: 15 }}>
                              {filesDescsNew[fileIndex].media_types.map(
                                (item, i) => {
                                  if (i < 2) {
                                    return (
                                      <p
                                        key={"media_" + item}
                                        style={{
                                          fontSize: 12,
                                          marginTop: -15,
                                          backgroundColor: "#ffe99b",
                                          paddingLeft: 2,
                                          borderRadius: 5,
                                          color: "#000",
                                        }}
                                      >
                                        {item}
                                      </p>
                                    );
                                  }
                                }
                              )}
                              {filesDescsNew[fileIndex].media_types.length - 2 >
                                0 && (
                                  <p
                                    key={"media_key"}
                                    style={{
                                      fontSize: 12,
                                      marginTop: -15,
                                      backgroundColor: "#ffe99b",
                                      paddingLeft: 2,
                                      borderRadius: 5,
                                      width: 35,
                                      color: "#000",
                                    }}
                                  >
                                    {filesDescsNew[fileIndex].media_types.length -
                                      2}
                                    +
                                  </p>
                                )}
                            </div>

                            <div style={{ width: 85, marginTop: 5 }}>
                              {filesDescsNew[fileIndex].content_types.map(
                                (item, i) => {
                                  if (i < 2) {
                                    return (
                                      <p
                                        key={"content_" + item}
                                        style={{
                                          fontSize: 12,
                                          marginTop: -15,
                                          backgroundColor: "#ffe99b",
                                          paddingLeft: 2,
                                          borderRadius: 5,
                                          color: "#000",
                                        }}
                                      >
                                        {item}
                                      </p>
                                    );
                                  }
                                }
                              )}
                              {filesDescsNew[fileIndex].content_types.length -
                                2 >
                                0 && (
                                  <p
                                    key={"content_key"}
                                    style={{
                                      fontSize: 12,
                                      marginTop: -15,
                                      backgroundColor: "#ffe99b",
                                      paddingLeft: 2,
                                      borderRadius: 5,
                                      width: 35,
                                      color: "#000",
                                    }}
                                  >
                                    {filesDescsNew[fileIndex].content_types
                                      .length - 2}
                                    +
                                  </p>
                                )}
                            </div>
                          </div>
                        )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>

      {productHighlights &&
        productHighlights?.map((item, index) => (
          <>
            {item.language_code == productDetail.language_code && (
              <div key={index}>
                <div className="row">
                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="title">Highlight Name</label>
                      <textarea
                        style={{ resize: "none", whiteSpace: "pre-wrap" }}
                        id="title"
                        maxLength={200}
                        name="title"
                        className="form-control"
                        rows={2}
                        disabled={
                          item.language_code &&
                          approval_status != "" &&
                          approval_status != null &&
                          approval_status != "REJECTED" &&
                          approval_status != "NOT SUBMITTED" &&
                          approval_status != "COMPLETED" &&
                          (approval_status != "ONREVISED" ||
                            next_step_nik_detail != userInfo.nik)
                        }
                        onChange={(e) => onDetailChangeTextHighlight(e, index)}
                        value={item.title}
                      />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="description">Highlight Description</label>
                      <textarea
                        style={{ resize: "none", whiteSpace: "pre-wrap" }}
                        id="description"
                        maxLength={200}
                        name="description"
                        className="form-control"
                        rows={2}
                        disabled={
                          item.language_code &&
                          approval_status != "" &&
                          approval_status != null &&
                          approval_status != "REJECTED" &&
                          approval_status != "NOT SUBMITTED" &&
                          approval_status != "COMPLETED" &&
                          (approval_status != "ONREVISED" ||
                            next_step_nik_detail != userInfo.nik)
                        }
                        onChange={(e) => onDetailChangeTextHighlight(e, index)}
                        value={item.description}
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div
                      className="form-group"
                      style={{ paddingTop: "40px", paddingInlineStart: "20px" }}
                    >
                      <a
                        type="button"
                        className={
                          !approval_status ||
                            approval_status == "NOT SUBMITTED" ||
                            approval_status == "REJECTED" ||
                            approval_status == "COMPLETED" ||
                            (approval_status == "ONREVISED" &&
                              next_step_nik_detail == userInfo.nik)
                            ? "btn btn-danger"
                            : "disabled btn btn-danger"
                        }
                        style={{ width: 50 }}
                        onClick={() => removeRow(item.line_num)}
                      >
                        <i className="fa fa-trash" />{" "}
                      </a>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="form-group" style={{ paddingTop: "40px" }}>
                      {(!approval_status ||
                        approval_status == "NOT SUBMITTED" ||
                        approval_status == "COMPLETED" ||
                        (approval_status == "ONREVISED" &&
                          next_step_nik_detail == userInfo.nik)) && (
                          <a
                            type="button"
                            className={
                              item.language_code
                                ? "btn btn-warning"
                                : "disabled btn btn-warning"
                            }
                            style={{ width: 50 }}
                            onClick={() => resetRow(index)}
                          >
                            <i className="fa fa-undo" />{" "}
                          </a>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ))}
      {productDetail.language_code &&
        (!approval_status ||
          approval_status == "NOT SUBMITTED" ||
          approval_status == "COMPLETED" ||
          approval_status == "REJECTED" ||
          (approval_status == "ONREVISED" &&
            next_step_nik_detail == userInfo.nik)) && (
          <div className="row">
            <div className="col-md-3">
              <p
                style={{ cursor: "pointer" }}
                onClick={() =>
                  addRow(
                    productHighlights.filter(
                      (high) =>
                        high.language_code == productDetail.language_code
                    ).length
                  )
                }
              >
                {" "}
                + Add Product Highlight{" "}
              </p>
            </div>
          </div>
        )}
      <div className="col-md-12">
        <div className="form-group">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: 16,
            }}
          >
            {/* {productDetail.language_code&&

                            <div style={{ width: 100 }}>
                                <button type="button" className="btn btn-block btn-dark" onClick={onHighlightSave}>
                                    <i className='fa fa-save'></i> Draft
                                </button>
                            </div>
                        } */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductHighlight;
